import React from "react";
import { useBnbSelector } from "../../../../redux/store";
import PriceFootNote from "./PriceFootNote";
import { type BuildAndBuyLabelType, BnbLabel, useBnbOptionalLabel } from "../../../../utils/labels";

const TotalPriceDisclaimers = (): JSX.Element => {
    const total = useBnbSelector(({ basket }) => basket.total);
    const financeOption = useBnbSelector(({ utils }) => utils.financeOption);
    const externalPrice = useBnbSelector((state) => state.externalPrice);

    const [
        wltpTotalPriceDisclaimer,
        wltpTotalMonthlyDisclaimer,
        genericTotalPriceDisclaimer,
        genericTotalMonthlyRateDisclaimer,
    ] = useBnbOptionalLabel([
        "wltpTotalPriceDisclaimer",
        "wltpTotalMonthlyDisclaimer",
        "T1.genericTotalPriceDisclaimer",
        "T1.genericTotalMonthlyRateDisclaimer",
    ]);

    let disclaimerLabel: BuildAndBuyLabelType | null = null;
    let useHTML = false;
    if (total.isExternalPrice) {
        if (financeOption === "monthly" && wltpTotalMonthlyDisclaimer) {
            disclaimerLabel = "wltpTotalMonthlyDisclaimer";
        } else if (financeOption === "cash" && wltpTotalPriceDisclaimer) {
            disclaimerLabel = "wltpTotalPriceDisclaimer";
        }
    } else if (externalPrice.hadError) {
        disclaimerLabel = "wltpTotalErrorDisclaimer";
    } else if (financeOption === "monthly" && genericTotalMonthlyRateDisclaimer) {
        disclaimerLabel = "T1.genericTotalMonthlyRateDisclaimer";
        useHTML = true;
    } else if (financeOption === "cash" && genericTotalPriceDisclaimer) {
        disclaimerLabel = "T1.genericTotalPriceDisclaimer";
        useHTML = true;
    }

    return (
        <>
            {disclaimerLabel && <BnbLabel label={disclaimerLabel} useHTML={useHTML} />}
            <PriceFootNote />
        </>
    );
};

export default TotalPriceDisclaimers;
